var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", {
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("收件信息")))]), _vm.edit ? _c("div", {
    attrs: {
      slot: "btn"
    },
    slot: "btn"
  }, [_c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.addConsigneeFun
    }
  }, [_vm._v(_vm._s(_vm.$t("新增") + _vm.$t("收件信息")))])], 1) : _vm._e()]), _vm.edit ? _c("a-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      bordered: "",
      columns: _vm.consigneeListColumns,
      "data-source": _vm.consigneeList,
      pagination: false,
      rowKey: "consigneeId",
      scroll: {
        y: 400
      },
      rowSelection: {
        selectedRowKeys: _vm.selectedRowKeysArray,
        onChange: _vm.onSelectChange,
        type: "radio"
      }
    },
    scopedSlots: _vm._u([{
      key: "address",
      fn: function (text, record) {
        return [_c("span", {
          staticClass: "marginR15"
        }, [_vm._v(_vm._s(text))]), record.isDefault == 1 ? _c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("默认地址")))]) : _vm._e()];
      }
    }, {
      key: "operation",
      fn: function (text, record) {
        return [record.isDefault != 1 ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "link",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDefault(record.consigneeId);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("设置默认")))]) : _vm._e(), _c("a-button", {
          attrs: {
            type: "linkDanger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDel(record.consigneeId);
            }
          }
        }, [_vm._v("删除")])];
      }
    }], null, false, 1699479780)
  }, _vm._l(_vm.consigneeListColumns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0) : _vm._e(), _vm.infoData.consigneeInfo && !_vm.edit ? _c("div", [_c("div", {
    staticClass: "nameCont"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("姓名")) + ":")]), _vm._v(_vm._s(_vm.infoData.consigneeInfo.name) + " "), _c("div", [_c("span", [_vm._v(_vm._s(_vm.$t("手机号")) + ":")]), _vm._v(_vm._s(_vm.infoData.consigneeInfo.mobile) + " ")])]), _c("div", {
    staticClass: "nameCont"
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("详细地址")) + ":")]), _vm._v(_vm._s(_vm.infoData.consigneeInfo.address) + " ")])]) : _vm._e(), _c("top-title", {
    staticClass: "marginT20",
    attrs: {
      background: true
    }
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("资料清单")))])]), _vm.edit ? _c("a-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      bordered: "",
      columns: _vm.documentListColumns,
      "data-source": _vm.documentList,
      pagination: false,
      rowKey: "documentId",
      scroll: {
        y: 300
      }
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "mail",
      fn: function (text, record, index) {
        return [_c("a-checkbox", {
          attrs: {
            checked: record.isChecked
          },
          on: {
            change: function ($event) {
              return _vm.mailChange(index);
            }
          }
        })];
      }
    }, {
      key: "remark",
      fn: function (text, record) {
        return [_c("a-input", {
          model: {
            value: record.remark,
            callback: function ($$v) {
              _vm.$set(record, "remark", $$v);
            },
            expression: "record.remark"
          }
        })];
      }
    }], null, false, 3217444100)
  }, _vm._l(_vm.documentListColumns, function (item, i) {
    var _item$slots4, _item$slots5, _item$slots6;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots4 = item.slots) === null || _item$slots4 === void 0 ? void 0 : _item$slots4.title
      },
      slot: (_item$slots5 = item.slots) === null || _item$slots5 === void 0 ? void 0 : _item$slots5.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots6 = item.slots) === null || _item$slots6 === void 0 ? void 0 : _item$slots6.title)))]);
  }), 0) : _vm._e(), !_vm.edit ? _c("a-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      bordered: "",
      columns: _vm.documentColumns,
      "data-source": _vm.infoData.list,
      pagination: false,
      rowKey: "documentId",
      scroll: {
        y: 300
      }
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "remark",
      fn: function (text, record) {
        return [_vm._v(" " + _vm._s(record.remark) + " ")];
      }
    }], null, false, 2383529954)
  }, _vm._l(_vm.documentColumns, function (item, i) {
    var _item$slots7, _item$slots8, _item$slots9;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots7 = item.slots) === null || _item$slots7 === void 0 ? void 0 : _item$slots7.title
      },
      slot: (_item$slots8 = item.slots) === null || _item$slots8 === void 0 ? void 0 : _item$slots8.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots9 = item.slots) === null || _item$slots9 === void 0 ? void 0 : _item$slots9.title)))]);
  }), 0) : _vm._e(), _vm.consigneeShow ? _c("consignee-model", {
    ref: "consigneeForm",
    on: {
      ok: _vm.consigneeFun,
      cancel: function ($event) {
        _vm.consigneeShow = false;
      }
    }
  }) : _vm._e(), _vm.edit ? _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.handleSure
    }
  }, [_vm._v(_vm._s(_vm.$t("通知客户邮寄")))])], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };